export type AprRuntimeConfig = {
  apiBaseUrl?: string;
  portalUrl?: string;
  adminUrl?: string;
  aprName?: string;
  tenantId?: string;
  dteUrl?: string;
};

declare global {
  interface Window {
    __APR_CONFIG__?: AprRuntimeConfig;
  }
}

function runtimeConfig(): AprRuntimeConfig {
  return typeof window === "undefined" ? {} : (window.__APR_CONFIG__ ?? {});
}

export function getApiBaseUrl(): string {
  return runtimeConfig().apiBaseUrl?.trim().replace(/\/$/, "") || "/api";
}

export function getPortalUrl(): string {
  return runtimeConfig().portalUrl?.trim() || "/portal";
}

export function getAdminUrl(): string {
  return runtimeConfig().adminUrl?.trim() || "/admin";
}

export function getTenantId(): string {
  return runtimeConfig().tenantId?.trim() || "demo";
}

export function getAprName(): string {
  return runtimeConfig().aprName?.trim() || "APR";
}
